import * as React from 'react';
import { HiddenInput, RadioLabel, OuterCircle, InnerCircle } from './styles.js';
import { jsx } from '@emotion/react';

var Radio = function Radio(_ref) {
  var children = _ref.children,
      group = _ref.group,
      handleSelected = _ref.handleSelected,
      id = _ref.id,
      isSelected = _ref.isSelected,
      size = _ref.size,
      value = _ref.value;
  return jsx(React.Fragment, null, jsx(HiddenInput, {
    checked: isSelected,
    "data-testid": "hidden-radio-input",
    id: id,
    name: group,
    onChange: handleSelected,
    type: "radio",
    value: value
  }), jsx(RadioLabel, {
    htmlFor: id,
    size: size
  }, jsx(OuterCircle, {
    "aria-checked": isSelected,
    "data-testid": "outer-circle",
    role: "radio",
    selected: isSelected,
    tabIndex: 0
  }, jsx(InnerCircle, {
    "data-testid": "inner-circle",
    selected: isSelected
  })), jsx("span", {
    "data-testid": "radio-label-wrap"
  }, children)));
};
Radio.displayName = 'Radio';
Radio.defaultProps = {
  isSelected: false,
  size: 'l'
};

export { Radio };
//# sourceMappingURL=radio.js.map
